import * as React from "react";
import {
    HistoricHand, PlayerAction, PlayerCardsDealt, TableCardsDealt,
    HandResult, GameCard, HandHistoryEvent, PlayerCardsExposed, PlayerBestHand, PotUpdate, PlayerBestLowHand, BonusPotEvent
} from "../../../../generated/protocol";
import {CardUtils} from "./CardUtils";
import {formatDate} from "../../util/date";
import {PokerTable, CardImage} from "./PokerTable";
import * as Big from "big.js";
import {Link} from "react-router";
import {isNewPokerServerTournament} from "../../../utils/PokPoker";

export class Hand extends React.Component<{ hand?: HistoricHand }, { pokerTableWidth?: number }> {

    listener: () => void;

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.setState({pokerTableWidth: $(".hand-history-table").width()});
        this.listener = () => {
            let width = $(".hand-history-table").width();
            this.setState({pokerTableWidth: width});
        }
        window.addEventListener("resize", this.listener.bind(this));

    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.listener)
    }

    render() {
        const hasLowHand = this.props.hand.settings.variant === "OMAHA_HL";
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">

                        <div className="ibox float-e-margins">
                            <div className="ibox-title">
                                <h5>Hand Summary</h5>
                            </div>
                            <div className="ibox-content">
                                <div className="row">
                                    <div className="col-lg-5">
                                        {this.getTableInfo()}
                                    </div>
                                    <div className="col-lg-7">
                                        <PokerTable
                                            width={this.state.pokerTableWidth}
                                            hand={this.props.hand}
                                            smallBlindPlayerId={this.smallBlindPlayerId()}
                                            bigBlindPlayerId={this.bigBlindPlayerId()}
                                            dealerPlayerId={this.dealerPlayerId()}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
                <div className="ibox float-e-margins ">
                    <div className="ibox-title">
                        <h5>Results</h5>
                    </div>
                    <div className="ibox-content">
                        <div className="row">
                            <div className="col-md-12">
                                <table className="table table-striped player-results-table">
                                    <thead>
                                    <tr>
                                        <th className="name">Player</th>
                                        <th className="playerId">Cubeia User Id</th>
                                        <th className="currency-amount">Starting Balance</th>
                                        <th className="currency-amount">Final Balance</th>
                                        <th className="currency-amount">Net Win</th>
                                        <th className="final-hand">Final Hand</th>
                                        {hasLowHand && <th className="final-low-hand">Final Low Hand</th>}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.getResultRows()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ibox float-e-margins ">
                    <div className="ibox-title">
                        <h5>Results</h5>
                    </div>
                    <div className="ibox-content">
                        <div className="row">
                            <div className="col-md-12">
                                <table className="table table-striped player-results-table">
                                    <thead>
                                    <tr>
                                        <th style={{width: "20%"}}>Player</th>
                                        <th>Action</th>
                                        <th>Amount</th>
                                        <th>Cards</th>
                                        <th>Time</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.getEvents()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div>

                </div>

            </div>


        );
    }


    getTableInfo() {
        var hand = this.props.hand;
        return (
            <table className="table table-striped table-info">
                <thead>
                <tr>
                    <th colSpan={2}>Summary</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Hand Id</td>
                    <td>{this.props.hand.id}</td>
                </tr>
                <tr>
                    <td>Table Name</td>
                    <td>{hand.table && hand.table.tableName}</td>
                </tr>
                <tr>
                    <td>Table Id</td>
                    <td>{hand.table && hand.table.tableId}</td>
                </tr>
                <tr>
                    <td>Table Int Id</td>
                    <td>{hand.table && hand.table.tableIntegrationId}</td>
                </tr>
                <tr>
                    <td>Start Time</td>
                    <td>{formatDate(hand.startTime)}</td>
                </tr>
                <tr>
                    <td>End Time</td>
                    <td>{formatDate(hand.endTime)}</td>
                </tr>
                <tr>
                    <td>Total Rake</td>
                    <td>{hand.results && "" + hand.results.totalRake}</td>
                </tr>
                <tr>
                    <td>Variant</td>
                    <td>{hand.settings && hand.settings.variant}</td>
                </tr>
                <tr>
                    <td>Bet Strategy</td>
                    <td>{hand.settings && hand.settings.betStrategyType}</td>
                </tr>
                <tr>
                    <td>Currency</td>
                    <td>{hand.settings && hand.settings.currencyCode}</td>
                </tr>
                <tr>
                    <td>Blinds</td>
                    <td>{hand.settings && hand.settings.ante > 0 && hand.settings.ante + "/"}{hand.settings && hand.settings.smallBlind}/{hand.settings && hand.settings.bigBlind}</td>
                </tr>
                <tr>
                    <td>Seats</td>
                    <td>{hand.settings && hand.settings.capacity > 0 && hand.settings.capacity}</td>
                </tr>
                {hand.historicTournamentId &&
                <tr>
                    <td>Tournament</td>
                    <td>{ this.renderTournamentLink(hand.historicTournamentId) }</td>
                </tr>
                }
                </tbody>
            </table>

        );

    }

    getVariantAndLimit() {
        var hand = this.props.hand;
        var variant = hand.settings.variant;
        var betStrategy = hand.settings.betStrategyType;
        return betStrategy + " " + variant;
    }

    getBlinds() {
        var hand = this.props.hand;
        var ante = "";
        if (hand.settings.ante > 0) {
            ante = "" + hand.settings.ante;
        }
        if (hand.settings.smallBlind > 0) {
            ante = ante + "/";
        }
        return ante + hand.settings.smallBlind + "/" + hand.settings.bigBlind;
    }

    getResultForPlayer(playerId) {
        return this.props.hand.results.results["" + playerId];
    }

    getResultRows() {

        var nrOfDecimals = CardUtils.getNrOfDecimals(this.props.hand);
        var items = [];
        var seats = this.props.hand.seats;
        for (var i = 0; i < seats.length; i++) {
            var seat = seats[i];
            var result: HandResult = CardUtils.getResultsForPlayer(this.props.hand.results, seat.playerId);
            var netWinClass = "";
            var netWin = 0;
            if (result) {
                netWin = result.netWin;
            }

            if (netWin < 0) {
                netWinClass = "lost";
            } else if (netWin > 0) {
                netWinClass = "won"
            }
            const finalLowHand = CardUtils.getFinalLowHand(this.props.hand.events, seat.playerId);
            items.push((
                <tr className="player-result" key={"res" + seat.playerId}>
                    <td className="name">{seat.name}</td>
                    <td className="player-id">{seat.playerId}</td>
                    <td className={'currency-amount'}>{new Big(seat.initialBalance).toFixed(nrOfDecimals)}</td>
                    <td className={'currency-amount'}>{new Big(seat.initialBalance).plus(new Big(netWin)).toFixed(nrOfDecimals)}</td>
                    <td className={'currency-amount ' + netWinClass}>{new Big(netWin).toFixed(nrOfDecimals)}</td>
                    <td className="final-hand">
                        <div className="final-hand-container">
                            {this.getFinalHandForPlayer(seat.playerId).map(c => {
                                return <div className="player-card"><CardImage card={c}/></div>;
                            })}
                        </div>
                    </td>
                   <td className="final-low-hand">
                       {finalLowHand &&
                       <div className="final-low-hand-container">
                           {finalLowHand.map(c => {
                               return <div className="player-card"><CardImage card={c}/></div>;
                           })}
                       </div>
                       }
                    </td>
                </tr>
            ));
        }
        return items;
    }

    getFinalHandForPlayer(playerId: number): GameCard[] {
        var events = this.props.hand.events;
        return CardUtils.getFinalHand(events, playerId);
    }

    getHandSummary() {
        return (
            <div className="player-results">

            </div>
        );
    }

    getEvents() {
        var phase = 0;
        var self = this;
        var events = [];
        var rows = [];
        var communityCards = [];
        var stackId = 0;
        communityCards.push([]);
        this.props.hand.events.forEach((event, i) => {
            var cards = null;
            if (event.type == "TableCardsDealt") {
                let e: TableCardsDealt = event;
                phase++;
                cards = e.cards;
                stackId = e.stackId;

            } else if ((event as PlayerAction).action == "SPLIT") {
                stackId = communityCards.push([communityCards[stackId].pop()]) - 1;
            }
            rows.push(this.getEventByAction(event, i, phase, self.props.hand.settings.variant, communityCards[stackId]));
            if (cards != null) {
                communityCards[stackId] = communityCards[stackId].concat(cards);
            }

        });
        return rows;
    }

    getPlayerNameById(id) {
        var seats = this.props.hand.seats;
        for (var i = 0; i < seats.length; i++) {
            if (seats[i].playerId == id) {
                return seats[i].name;
            }
        }
        return "N/A";
    }

    getCard(card, index) {
        return CardUtils.getCard(card, index);
    }

    getCards(cards) {
        return CardUtils.getCards(cards);
    }

    getActionText(action: string) {
        return <span
            className={"poker-action-label label label-" + this.getActionLabel(action)}>{action && action.replace(/_/g, " ")}</span>
    }

    getActionLabel(action: string) {
        if (action.startsWith("BIG_") || action.startsWith("SMALL") || action.startsWith("ENTRY") || action == "BET" || action == "RAISE") {
            return "primary";
        } else if (action == "FOLD") {
            return "danger";
        } else if (action == "CHECK" || action == "CALL") {
            return "warning";
        } else {
            return "default";
        }
    }

    getPlayerCardById(id: number): GameCard {
        var card;
        var events = this.props.hand.events;
        for (var i = 0; i < events.length; i++) {
            var e = events[i];
            if (e.type == "PlayerCardsDealt") {
                card = (e as PlayerCardsDealt).cards.find((c: GameCard) => {
                    return c.id === id;
                });
            }
            if (card) {
                break;
            }
        }

        return card;
    }

    getEventByAction(event: HandHistoryEvent, index, phase, variant, previousCommunityCards) {
        const type = event.type;
        if ("PlayerCardsDealt" == type) {
            let playerCardsDealt: PlayerCardsDealt = event;
            return (
                <tr className="player-cards-dealt" key={index}>
                    <td className="player">
                        {this.getPlayerNameById(playerCardsDealt.playerId)}
                    </td>
                    <td className="action">
                        Was dealt
                    </td>
                    <td></td>
                    <td className="">
                        {
                            playerCardsDealt.cards.map(c => {
                                return <div key={c.id} className="player-card"><CardImage card={c}/></div>
                            })
                        }
                    </td>
                    <td className="time">
                        {formatDate(event.time)}
                    </td>
                </tr>
            );
        } else if ("TableCardsDealt" == type) {
            let tableCardsDealt: TableCardsDealt = event;


            return (
                <tr className="table-cards-dealt" key={index}>
                    <td className="player"
                        style={{textTransform: "uppercase", fontWeight: "bold", fontSize: "120%", lineHeight: 3}}>
                        <span className="phase-title">{CardUtils.getPhaseByVariant(phase, variant)}</span>
                    </td>
                    <td></td>
                    <td></td>
                    <td className="">

                            <span className="previous-cards">
                                {
                                    previousCommunityCards.map(c => {
                                        return <div key={c.id} className="player-card"><CardImage card={c}/></div>
                                    })
                                }
                            </span>
                        {tableCardsDealt.cards.map(c => <div key={c.id} className="player-card"><CardImage card={c}/>
                        </div>)}
                    </td>
                    <td className="time">
                        {formatDate(event.time)}
                    </td>
                </tr>
            );
        } else if ("PlayerCardsExposed" == type) {
            let playerCardsExposed: PlayerCardsExposed = event;
            return (
                <tr className="player-cards-exposed" key={index}>
                    <td className="player">
                        {this.getPlayerNameById(playerCardsExposed.playerId)}
                    </td>
                    <td className="action">
                        Showing Pocket Cards
                    </td>
                    <td></td>
                    <td className="">
                        {playerCardsExposed.cards.map(c => <div key={c.id} className="player-card"><CardImage card={c}/>
                        </div>)}
                    </td>
                    <td className="time">
                        {formatDate(event.time)}
                    </td>
                </tr>
            );
        } else if ("PlayerBestHand" == type) {
            let playerBestHand: PlayerBestHand = event;
            return (
                <tr className="player-best-hand" key={index}>
                    <td className="player">
                        {this.getPlayerNameById(playerBestHand.playerHand.playerId)}
                    </td>
                    <td className="action">
                        <span
                            className="label poker-hand-label">{this.getHandType((playerBestHand.handInfoCommon as any).handType)}</span>
                    </td>
                    <td></td>
                    <td className="">
                        {playerBestHand.bestHandCards.map(c => <div key={c.id} className="player-card"><CardImage
                            card={c}/></div>)}

                    </td>
                    <td className="time">
                        {formatDate(event.time)}
                    </td>
                </tr>
            );
        } else if ("PlayerBestLowHand" == type) {
            let playerBestHand: PlayerBestLowHand = event;
            return (
                <tr className="player-best-hand" key={index}>
                    <td className="player">
                        {this.getPlayerNameById(playerBestHand.playerHand.playerId)}
                    </td>
                    <td className="action">
                        <span
                            className="label poker-hand-label">LOW HAND</span>
                    </td>
                    <td></td>
                    <td className="">
                        {playerBestHand.cards.map(c => <div key={c.id} className="player-card"><CardImage
                            card={c}/></div>)}

                    </td>
                    <td className="time">
                        {formatDate(event.time)}
                    </td>
                </tr>
            );
        }  else if ("PlayerAction" == type) {
            let playerAction: PlayerAction = event;
            if (playerAction.action == "FOLD" && this.isBjGame(variant)) {
                return;
            }
            let cardsClass = "";
            if (playerAction.cards && playerAction.cards.length > 0) {
                cardsClass = "player-action-cards";
            }
            return (
                <tr className={"amount-action " + cardsClass} key={index}>
                    <td className="player">
                        {this.getPlayerNameById(playerAction.playerId)}
                    </td>
                    <td className="action">
                            <span className={playerAction.action + ' player-action'}>
                                {this.getActionText(playerAction.action)} {playerAction.timeout &&
                            <span alt="Player Timed Out" className="fa fa-clock-o "
                                  style={{color: "rgb(255, 69, 69)"}}></span>}
                            </span>
                    </td>
                    <td className="amount">
                        {this.getActionValue(event)} {playerAction.balanceAfterAction == 0 &&
                    <span className="label label-danger">All-in</span>}
                    </td>
                    <td></td>
                    <td className="time">
                        {formatDate(event.time)}
                    </td>
                </tr>
            );
        } else if ("PotUpdate" == type) {
            let potUpdate: PotUpdate = event;
            return (
                <tr>
                    <td>Pot Update</td>
                    <td></td>
                    <td>
                        {
                            potUpdate.pots.map(p => {
                                return <span>Pot {p.potId > 0 && p.potId}: <span className="pot-size">{p.potSize}</span> </span>
                            })
                        }
                    </td>
                    <td></td>
                    <td>{formatDate(event.time)}</td>
                </tr>
            );
        } else if ("BonusPotEvent" == type) {
            let bonusPotEvent: BonusPotEvent = event;
            return (
                <tr>
                    <td>Bonus Pot Event</td>
                    <td></td>
                    <td>
                        <span> Amount : <span class="pot-size">{bonusPotEvent.bonusAmount}</span></span>
                    </td>
                    <td></td>
                    <td>{formatDate(event.time)}</td>
                </tr>
            );
        }


    }

    getHandType(text: string) {
        return text && text.replace(/_/g, " ");
    }

    isBjGame(variant: string): boolean {
        return (variant == "FOUR_CARD_21" || variant == "FOUR_CARD_21_BO7" || variant == "HOLDEM_21_RUSH");
    }

    getPhaseByVariant(phase: number, variant: string): string {
        if (variant == "TEXAS_HOLDEM" || variant == "TEXAS_HOLDEM_JOKER" || variant == "OMAHA" || variant == "CRAZY_PINEAPPLE") {
            if (phase == 0) {
                return "Pre-flop";
            } else if (phase == 1) {
                return "Flop"
            } else if (phase == 2) {
                return "Turn"
            } else if (phase == 3) {
                return "River"
            }
        }
        if (variant == "FOUR_CARD_21" || variant == "FOUR_CARD_21_BO7") {
            return "Cards Played";
        }
        if (variant == "HOLDEM_21_RUSH" && phase != 1) {
            return "Hit";
        }
        return "Table Cards Dealt";
    }

    smallBlindPlayerId(): number {
        const smallBlindActions = ['SMALL_BLIND', 'ANTE_PLUS_SMALL_BLIND']
        const smallBlindEvent = this.props.hand.events.find(e => e.type === "PlayerAction" && smallBlindActions.indexOf(e.action) !== -1)
        return smallBlindEvent ? smallBlindEvent.playerId : 0;
    }

    bigBlindPlayerId(): number {
        const bigBlindActions = ['BIG_BLIND', 'ANTE_PLUS_BIG_BLIND', 'BIG_BLIND_PLUS_DEAD_SMALL_BLIND', 'ANTE_PLUS_BIG_BLIND_PLUS_DEAD_SMALL_BLIND']
        const bigBlindEvent = this.props.hand.events.find(e => e.type === "PlayerAction" && bigBlindActions.indexOf(e.action) !== -1)
        return bigBlindEvent ? bigBlindEvent.playerId : 0;
    }

    dealerPlayerId(): number {
        // dealer is always dealt last
        const cardsDealtEvents = this.props.hand.events.filter(e => e.type === "PlayerCardsDealt");
        if (cardsDealtEvents.length === 0) return 0;
        return cardsDealtEvents[cardsDealtEvents.length - 1].playerId;
    }

    getActionValue(event: PlayerAction): any {
        if (event.cards && event.cards.length > 0) {
            return (event as PlayerAction).cards.map((cardId) => {
                var c = this.getPlayerCardById(cardId);
                console.log("action value card = ", c, cardId);
                return <div key={c.id} className="player-card"><CardImage card={c}/></div>
            });
        } else if (event.amount && event.amount.amount != 0) {
            return <span className="label-poker-chips"><span>{event.amount.amount}</span></span>
        }
        return false;
    }

    renderTournamentLink(tournamentId: string) {
        return isNewPokerServerTournament(tournamentId) ?
            <a
                href={`${adminBaseUrl}/gamemanagement/tournament-history/${tournamentId}`}
                target='_blank'
            >
                {tournamentId}
            </a>
            :
            <Link to={`/historic-tournament/${tournamentId}`}>{tournamentId}</Link>
            ;
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/poker/history/Hand.tsx